import { api } from './api';

const getContactInfo = async (params) => {
    const response = await api({
        url: `Contacts/getPagedList`,
        method: 'GET',
        params,
    });
    return response.data;
};

const contactsServices = { getContactInfo };

export default contactsServices;
